
blog.classy.controller({
   name: 'blogController',
   inject: ['$scope', '$rootScope', 'authServiceFactory', '$http', '$sce'],
   init: function()
   {
		var parent = this;
      parent.$.list = [];

		this.$http.get("/api/Blog").then(function(result) {
         for (let post in result.data) {
            var id = result.data[post].id;
            if (id==33 || id==28 || id==27 || id==16) {
               parent.$.list.push(result.data[post]);
            }
         }
         parent.$.selectedItem = parent.$.list[0];
         parent.$.selectedItem.message = parent.$sce.trustAsHtml(parent.$.selectedItem.message);
		});
   },
   selectItem: function(i) {
   		this.$.selectedItem = this.$.list[i];
   		this.$.selectedItem.message = this.$sce.trustAsHtml(this.$.selectedItem.message);
   }

});

